import { PERMISSION_TYPES } from "../language/permissionTypes";

export const pathPermissionChecker = (to, from, isPermissionGranted, messageError, routerPush, that) => {
    const taskPermissions = [
        PERMISSION_TYPES["task.read"].tr.name,
        PERMISSION_TYPES["task.detailRead"].tr.name,
    ];
    if (to.path.match(/^\/mails(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["mail.read"].tr.name)) {
            messageError(that.$t("permissionErrors.chatRead"));
            routerPush("/denied");
        }
    }

    if (to.path.match(/^\/chat(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chat.get"].tr.name)) {
            messageError(that.$t("permissionErrors.chatRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/visitors(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["visitor.list.view"].tr.name)) {
            messageError(that.$t("permissionErrors.visitorListRead"));
            routerPush("/denied");
        }
    }
    // if (to.path.match(/^\/chatbot(\/.*)?$/)) {
    //     if (!isPermissionGranted(PERMISSION_TYPES["chatbot.view"].tr.name)) {
    //         messageError(that.$t("permissionErrors.chatbotStoryRead"));
    //         routerPush("/denied");
    //     }
    // }
    if (to.path.match(/^\/chatbot\/stories(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chatbot.stories.view"].tr.name)) {
            messageError(that.$t("permissionErrors.chatbotStoryRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/chatbot\/integrations(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chatbot.integrations.view"].tr.name)) {
            messageError(that.$t("permissionErrors.chatbotStoryRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/chatbot\/templates(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chatbot.templates.view"].tr.name)) {
            messageError(that.$t("permissionErrors.chatbotStoryRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/chatbot\/ai\/templates(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chatbot.aitemplates.view"].tr.name)) {
            messageError(that.$t("auto.chatbotAiTemplatesReadPermission"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/chatbot\/archive(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chatbot.archive.view"].tr.name)) {
            messageError(that.$t("permissionErrors.chatbotStoryRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/chatbot\/entities(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chatbot.entities.view"].tr.name)) {
            messageError(that.$t("permissionErrors.chatbotStoryRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/chatbot\/training(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chatbot.training.view"].tr.name)) {
            messageError(that.$t("permissionErrors.chatbotStoryRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/chatbot\/reports(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["chatbot.reports.view"].tr.name)) {
            messageError(that.$t("permissionErrors.chatbotStoryRead"));
            routerPush("/denied");
        }
    }

    if (to.path.match(/^\/tasks(\/.*)?$/)) {
        const hasPermission = taskPermissions.some((permission) => isPermissionGranted(permission));
        if (!hasPermission) {
            messageError(that.$t("permissionErrors.taskRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/ticket(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["offlineSupportRequest.get"].tr.name)) {
            messageError(that.$t("permissionErrors.offlineSupportRequestRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/archives(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["archives.get"].tr.name)) {
            messageError(that.$t("permissionErrors.archiveRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/triggers(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["trigers.view"].tr.name)) {
            messageError(that.$t("permissionErrors.triggerRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/settings(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["setting.get"].tr.name)) {
            messageError(that.$t("permissionErrors.settingRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/integrations$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["integrations.view"].tr.name)) {
            messageError(that.$t("permissionErrors.integrationsRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/integrations\/instagram(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["integrations.instagram.view"].tr.name)) {
            messageError(that.$t("permissionErrors.instagramIntegrationRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/integrations\/messenger(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["integrations.messenger.view"].tr.name)) {
            messageError(that.$t("auto.messengerIntegrationReadPermission"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/integrations\/(whatsapp-business-api|whatsapp-v2)(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["integrations.whatsapp.view"].tr.name)) {
            messageError(that.$t("permissionErrors.whatsappIntegrationRead"));
            routerPush("/denied");
        }
    }
    if (to.path.match(/^\/report-new(\/.*)?$/)) {
        if (!isPermissionGranted(PERMISSION_TYPES["report.get"].tr.name)) {
            messageError(that.$t("permissionErrors.reportRead"));
            routerPush("/denied");
        }
    }
};
